import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 19h14m1.986 -1.977a2 2 0 0 0 -.146 -.773l-7.1 -12.25a2 2 0 0 0 -3.5 0l-.815 1.405m-1.488 2.568l-4.797 8.277a2 2 0 0 0 1.75 2.75","key":"svg-0"}],["path",{"d":"M3 3l18 18","key":"svg-1"}]]

const IconBleachOff = createReactComponent('outline', 'bleach-off', 'BleachOff', __iconNode);

export default IconBleachOff;